import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { successStories } from '../data/mockData';
import { Quote, ArrowRight } from 'lucide-react';

const SuccessStories = () => {
  const header = useScrollAnimation({ threshold: 0.15 });
  return (
    <section data-testid="success-stories-section" className="py-24 md:py-32 bg-[#093336]/20 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-16 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="inline-block bg-[#A5BF23]/10 text-[#A5BF23] px-4 py-1.5 rounded-full text-xs font-bold tracking-[0.2em] mb-4">SUCCESS STORIES</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F0F4F4] mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Brand Names We've Protected</h2>
          <p className="text-base text-[#A0B2B2] leading-relaxed">See how businesses secured their brand names through trademark registration and gained a competitive edge.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {successStories.map((story, i) => <StoryCard key={story.id} story={story} index={i} />)}
        </div>
      </div>
    </section>
  );
};

const StoryCard = ({ story, index }) => {
  const card = useScrollAnimation({ threshold: 0.1 });
  return (
    <div ref={card.ref} data-testid={`success-story-${index}`}
      className={`group bg-[#093336]/60 backdrop-blur-sm border border-white/5 rounded-2xl overflow-hidden transition-all duration-300 hover:border-[#A5BF23]/40 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(165,191,35,0.08)] scroll-fade-up scroll-delay-${index + 1} ${card.isVisible ? 'scroll-visible' : ''}`}>
      <div className="relative h-48 overflow-hidden">
        <img src={story.image} alt={story.client} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#041B1C] to-transparent" />
        <div className="absolute bottom-4 left-4 right-4">
          <span className="text-xs font-semibold text-[#A5BF23] bg-[#041B1C]/80 px-3 py-1 rounded-full">{story.industry}</span>
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-lg font-bold text-[#F0F4F4] mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>{story.client}</h3>
        <p className="text-sm text-[#A5BF23] font-medium mb-4 flex items-center gap-1">
          {story.result} <ArrowRight className="w-3 h-3" />
        </p>
        <Quote className="w-5 h-5 text-[#A5BF23]/20 mb-2" />
        <p className="text-sm text-[#A0B2B2] leading-relaxed italic">"{story.quote}"</p>
      </div>
    </div>
  );
};

export default SuccessStories;
